<script>
	import Swal from "sweetalert2";

	async function showSuccessModal(message = "Sua requisição foi enviada.", title = "Sucesso") {
		return Swal({
			title,
			text: message,
			type: "success",
			confirmButtonClass: "btn btn-success",
			buttonsStyling: false,
			animation: false
		});
	}

	async function showFailModal(message = "Houve uma falha ao processar sua requisição", title = "Erro") {
		return Swal({
			title,
			text: message,
			type: 'error',
			confirmButtonClass: 'btn btn-danger',
			buttonsStyling: false,
			animation: false
		});
	}

	async function showConfirmationModal(text1 = 'Tem certeza?') {
		return Swal({
			title: text1,
			type: 'warning',
			animation: false,
			showCancelButton: true,
			confirmButtonText: 'Login',
			cancelButtonText: 'Registrar agora',
			confirmButtonClass: 'btn btn-success',
			cancelButtonClass: 'btn btn-danger',
			buttonsStyling: false
		});
	}

	// async function showConfirmationModal(text1 = 'Tem certeza?', text2 = 'Não é possível reverter a operação!') {
	// 	return Swal({
	// 		title: text1,
	// 		text: text2,
	// 		type: 'warning',
	// 		animation: false,
	// 		showCancelButton: true,
	// 		confirmButtonText: 'Sim',
	// 		cancelButtonText: 'Não',
	// 		confirmButtonClass: 'btn btn-success',
	// 		cancelButtonClass: 'btn btn-danger',
	// 		buttonsStyling: false
	// 	});
	// }

	function executeAsync(asyncFunction, successMessage, errorMessage, errorHandler) {
		asyncFunction()
			.then(() => {
				if (successMessage) {
					return showSuccessModal(successMessage);
				}
			})
			.catch(error => {
				if (errorHandler) {
					return errorHandler(error);
				}

				if (error.error === "ERR_BAD_REQUEST" && error.errorDetails) {
					return showFailModal(`Erro de validação: ${error.errorDetails}`);
				}

				switch(error.message) {
					case "MISSING_FIELDS":
						return showFailModal("Preencha os campos obrigatórios");
					case "CANCELLED":
						return showFailModal("A requisição foi cancelada", "Cancelado");
					case "NOT_ALLOWED":
						return showFailModal("Operação não permitida");
					case "ERR_DUPLICATE":
						return showFailModal("Registro já cadastrado");
				}

				console.error(error);

				if (errorMessage) {
					return showFailModal(errorMessage);
				}
			});
	}

	async function readFileAsText(file) {
		return new Promise((resolve, reject) => {
			const reader = new FileReader();

			reader.onload = (event) => resolve(event.target.result);
			reader.onabort = () => reject(Error("ERR_FILE_READ"));
			reader.onerror = (event) => reader.abort();

			reader.readAsText(file);
		});
	}

	export default {
		showSuccessModal,
		showFailModal,
		showConfirmationModal,
		executeAsync,
		readFileAsText,
	}
</script>




// WEBPACK FOOTER //
// src/components/EspressoAux.vue